/**
 * <nia-story>
 * Entrada de los capítulos e índice lateral.
 *
 * El estado oculto vive tras el atributo data-animate, que solo pone este
 * script: sin JavaScript, o con movimiento reducido, los capítulos son
 * visibles desde el primer render. El JS nunca es requisito para leer.
 */
class NiaStory extends HTMLElement {
  connectedCallback() {
    this.chapters = Array.from(this.querySelectorAll('.nia-sc'));
    this.links = Array.from(this.querySelectorAll('[data-story-index-link]'));

    if (!('IntersectionObserver' in window)) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.dataset.animate === 'true' && !reduced) this.#animate();
    if (this.links.length > 0) this.#trackIndex();
  }

  disconnectedCallback() {
    this.entryObserver?.disconnect();
    this.indexObserver?.disconnect();
  }

  #animate() {
    this.entryObserver = new IntersectionObserver(
      (entries, observer) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-in');
          // Una sola vez: releer no debe volver a animar.
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );

    for (const chapter of this.chapters) {
      chapter.dataset.animate = '';
      this.entryObserver.observe(chapter);
    }
  }

  /** Marca en el índice el capítulo que más superficie ocupa en pantalla. */
  #trackIndex() {
    this.indexObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const id = entry.target.id;
          for (const link of this.links) {
            link.setAttribute('aria-current', String(link.dataset.storyIndexLink === id));
          }
        }
      },
      { rootMargin: '-45% 0px -45% 0px' }
    );

    for (const chapter of this.chapters) {
      if (chapter.id) this.indexObserver.observe(chapter);
    }
  }
}

if (!customElements.get('nia-story')) {
  customElements.define('nia-story', NiaStory);
}
